import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, put, post, deleteRequest } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import TABLE_TYPES from 'common/components/table/store/types';

/* Purchasing Stores Actions */
export const getLinkedPurchasingStores = createAsyncThunk(
  'GET_PURCHASING_STORES',
  async (params, { rejectWithValue }) => {
    try {
      const res = await get('/enums/purchasing-stores', { ...params });

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const getNotLinkedPurchasingStores = createAsyncThunk(
  'GET_NOT_LINKED_PURCHASING_STORES',
  async (params, { rejectWithValue, dispatch }) => {
    const { organization_id, table, ...rest } = params;

    dispatch({
      type: TABLE_TYPES.GET_TABLE_LIST.START,
      payload: { params, table, data: [] }
    });

    try {
      const res = await get(`/organizations/${organization_id}/purchasing-stores`, { ...rest });

      dispatch({
        type: TABLE_TYPES.GET_TABLE_LIST.SUCCESS,
        payload: { data: res?.data || [], table }
      });

      return res.data;
    } catch (error) {
      dispatch({ type: TABLE_TYPES.GET_TABLE_LIST.ERROR, payload: { error, table } });

      return rejectWithValue(error);
    }
  }
);

export const getPurchasingStoresEquivalents = createAsyncThunk(
  'GET_PURCHASING_STORES_EQUIVALENTS',
  async (params, { rejectWithValue, dispatch }) => {
    const { id, table, ...rest } = params;

    dispatch({
      type: TABLE_TYPES.GET_TABLE_LIST.START,
      payload: { params, table, data: [] }
    });

    try {
      const res = await get(`/enums/purchasing-stores/${id}/equivalents`, { ...rest });

      dispatch({
        type: TABLE_TYPES.GET_TABLE_LIST.SUCCESS,
        payload: { data: res?.data || [], table }
      });

      return res.data;
    } catch (error) {
      dispatch({ type: TABLE_TYPES.GET_TABLE_LIST.ERROR, payload: { error, table } });

      return rejectWithValue(error);
    }
  }
);

export const createPurchasingStore = createAsyncThunk(
  'CREATE_PURCHASING_STORE',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await post('/enums/purchasing-stores', params);
      dispatch(
        successHandler({ title: 'Success!', message: 'Purchasing store created successfully' })
      );

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const linkPurchasingStore = createAsyncThunk(
  'LINK_PURCHASING_STORE',
  async (params, { rejectWithValue, dispatch }) => {
    const { id, ...rest } = params;

    try {
      const res = await post(`/enums/purchasing-stores/${id}/link`, { ...rest });

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const importCompaniesToPurchasingStore = createAsyncThunk(
  'IMPORT_COMPANIES_TO_PURCHASING_STORE',
  async (params, { rejectWithValue, dispatch }) => {
    const { id } = params;

    try {
      const res = await post(`/enums/purchasing-stores/${id}/import`, params);

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const editPurchasingStore = createAsyncThunk(
  'EDIT_PURCHASING_STORE',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { id, ...rest } = params;

      const res = await put(`/enums/purchasing-stores/${id}`, { ...rest });
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return res.data?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deletePurchasingStore = createAsyncThunk(
  'DELETE_PURCHASING_STORES',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { id } = params;

      const res = await deleteRequest(`/enums/purchasing-stores/${id}`);
      dispatch(successHandler({ title: 'Success!', message: 'Deleted successfully' }));

      return res.data?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

/* -- */
